import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config"
import {log} from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

const getHeaders = (token) => ({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Accept": "application/json"
})

export const getClientServicesLimitations = async (token) => {
    log("welcome in getClientServicesLimitations")

    if (!token || token === "") {
        return {error: true, message: "No token provided", limitations: []}
    }

    try {
        const url = BASE_URL + '/home/get_client_services_limitations_api'
        const result = await axios.get(url, {headers: getHeaders(token)})
        log("result.data from getClientServicesLimitations")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getClientServicesLimitations")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la incarcarea limitarilor", limitations: []}
    }
}

export const createClientServicesLimitation = async (token, data) => {
    log("welcome in createClientServicesLimitation")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/create_client_services_limitation_api'
        const result = await axios.post(url, data, {headers: getHeaders(token)})
        log("result.data from createClientServicesLimitation")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in createClientServicesLimitation")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la crearea limitarii"}
    }
}

export const updateClientServicesLimitation = async (token, id, data) => {
    log("welcome in updateClientServicesLimitation")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/update_client_services_limitation_api'
        const result = await axios.put(url, {id, ...data}, {headers: getHeaders(token)})
        log("result.data from updateClientServicesLimitation")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in updateClientServicesLimitation")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la actualizarea limitarii"}
    }
}

export const deleteClientServicesLimitation = async (token, id) => {
    log("welcome in deleteClientServicesLimitation")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/delete_client_services_limitation_api'
        const result = await axios.delete(url, {
            headers: getHeaders(token),
            data: {id}
        })
        log("result.data from deleteClientServicesLimitation")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in deleteClientServicesLimitation")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la stergerea limitarii"}
    }
}

export const getUsageCountForLimitation = async (token, clientId, serviceId, simId = null) => {
    log("welcome in getUsageCountForLimitation")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const url = BASE_URL + '/home/get_usage_count_for_limitation_api'
        const params = {client_id: clientId, service_id: serviceId}
        if (simId) {
            params.sim_id = simId
        }
        const result = await axios.get(url, {
            headers: getHeaders(token),
            params
        })
        log("result.data from getUsageCountForLimitation")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getUsageCountForLimitation")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la verificarea utilizarilor"}
    }
}

export const getBillingPeriods = async (token) => {
    log("welcome in getBillingPeriods")

    if (!token || token === "") {
        return {error: true, message: "No token provided", billing_periods: []}
    }

    try {
        const url = BASE_URL + '/home/get_billing_periods_api'
        const result = await axios.get(url, {headers: getHeaders(token)})
        log("result.data from getBillingPeriods")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getBillingPeriods")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la incarcarea perioadelor", billing_periods: []}
    }
}

export const getServicesForLimitations = async (token) => {
    log("welcome in getServicesForLimitations")

    if (!token || token === "") {
        return {error: true, message: "No token provided", services: []}
    }

    try {
        const url = BASE_URL + '/home/get_services_for_limitations_api'
        const result = await axios.get(url, {headers: getHeaders(token)})
        log("result.data from getServicesForLimitations")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getServicesForLimitations")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la incarcarea serviciilor", services: []}
    }
}

const useClientServicesLimitationsAPI = () => {
    return {
        error,
        getClientServicesLimitations,
        createClientServicesLimitation,
        updateClientServicesLimitation,
        deleteClientServicesLimitation,
        getUsageCountForLimitation,
        getBillingPeriods,
        getServicesForLimitations
    }
}

export default useClientServicesLimitationsAPI
